document.addEventListener("DOMContentLoaded", function () {
  const invoiceForm = document.getElementById("paymentForm");
  if (!invoiceForm) return;

  invoiceForm.addEventListener("submit", function (event) {
    event.preventDefault();

    // If City accidentally holds a combined "City, State, Zip" string, split it
    splitCityStateZipIntoFields(val("billing_city"));

    const billing = collectBillingAddressFromForm();

    const formData = {
      name: document.getElementById("name").value,
      email: document.getElementById("email").value,
      price: document.getElementById("amount").value,
      customerID: document.getElementById("customer_id").value,
      TaxPrice: document.getElementById("taxprice").value,
      billingAddress: billing
    };

    if (!formData.name || !formData.email) {
      alert("Please enter your name and email.");
      return;
    }

    const submitButton = document.getElementById("submit-payment");
    setButtonState(submitButton, true, "Processing...");

    checkCustomerExists(formData)
      .then(customerResult => {
        const customerId = customerResult.customerId
          ? customerResult.customerId.replace("gid://shopify/Customer/", "")
          : formData.customerID;

        const originalLineItems = $("#output").text();
        let orderOutput;
        let realLineItems;
        try {
          if (!originalLineItems || originalLineItems.trim() === "") {
            throw new Error("Order items are missing. Please close this window and submit the order again.");
          }
          orderOutput = JSON.parse(originalLineItems);
          realLineItems = orderOutput && orderOutput.line_items;
          if (!Array.isArray(realLineItems) || realLineItems.length === 0) {
            throw new Error("Order items are empty. Please close this window, fix any shipping/delivery date issues, and submit again.");
          }
          if (realLineItems.length > 499) {
            throw new Error(`This order has ${realLineItems.length} line items. Shopify draft orders accept a maximum of 499 line items.`);
          }
        } catch (e) {
          setButtonState(submitButton, false, "Submit Order for Review");
          alert(e.message || "Order line items JSON is invalid. Please submit the order again.");
          return;
        }

        const note = buildBulkOrderNote(formData, billing);

        return createDraftOrder({
          variantId: "49233818911031",
          quantity: 1,
          email: formData.email,
          name: formData.name,
          customerID: customerId,
          taxprice: formData.TaxPrice,
          output: originalLineItems,
          // Send the actual product/shipping variant lines. The PHP endpoint maps
          // these to DraftOrderLineItemInput instead of making custom line items.
          lineItems: realLineItems,
          currency: orderOutput.currency || "USD",
          // Mapped to DraftOrderInput.acceptAutomaticDiscounts so the Volume Discount tiers apply
          acceptAutomaticDiscounts: true,
          note: note,
          tags: ["bulk_order"],
          billingAddress: billing,
          phone: billing.phone || ""
        });
      })
      .then(handleDraftOrderSuccess(submitButton))
      .catch(handleError);
  });
});

var US_STATE_NAME_TO_CODE = {
  alabama: "AL", alaska: "AK", arizona: "AZ", arkansas: "AR", california: "CA",
  colorado: "CO", connecticut: "CT", delaware: "DE", florida: "FL", georgia: "GA",
  hawaii: "HI", idaho: "ID", illinois: "IL", indiana: "IN", iowa: "IA",
  kansas: "KS", kentucky: "KY", louisiana: "LA", maine: "ME", maryland: "MD",
  massachusetts: "MA", michigan: "MI", minnesota: "MN", mississippi: "MS", missouri: "MO",
  montana: "MT", nebraska: "NE", nevada: "NV", "new hampshire": "NH", "new jersey": "NJ",
  "new mexico": "NM", "new york": "NY", "north carolina": "NC", "north dakota": "ND",
  ohio: "OH", oklahoma: "OK", oregon: "OR", pennsylvania: "PA", "rhode island": "RI",
  "south carolina": "SC", "south dakota": "SD", tennessee: "TN", texas: "TX", utah: "UT",
  vermont: "VT", virginia: "VA", washington: "WA", "west virginia": "WV", wisconsin: "WI",
  wyoming: "WY", "district of columbia": "DC", "washington dc": "DC", "puerto rico": "PR"
};

function normalizeUsStateCode(stateRaw) {
  var s = String(stateRaw || "").trim();
  if (!s) return "";
  if (/^[A-Za-z]{2}$/.test(s)) return s.toUpperCase();
  return US_STATE_NAME_TO_CODE[s.toLowerCase()] || s;
}

/** Supports: "Chicago, Illinois, 60007" | "Los Angeles, CA, 92811" | "Los Angeles, CA 92811" */
function parseCityStateZip(combined) {
  var raw = String(combined || "").trim();
  if (!raw) return { city: "", province: "", zip: "" };

  var m = raw.match(/^(.+?),\s*([A-Za-z][A-Za-z\s.]+?),\s*(\d{5}(?:-\d{4})?)\s*$/);
  if (m) {
    return { city: m[1].trim(), province: normalizeUsStateCode(m[2]), zip: m[3] };
  }

  m = raw.match(/^(.+?),\s*([A-Za-z]{2})\s+(\d{5}(?:-\d{4})?)\s*$/);
  if (m) {
    return { city: m[1].trim(), province: normalizeUsStateCode(m[2]), zip: m[3] };
  }

  m = raw.match(/^(.+?)\s+([A-Za-z]{2}|[A-Za-z][A-Za-z\s.]{2,}?)\s+(\d{5}(?:-\d{4})?)\s*$/);
  if (m) {
    var maybeState = normalizeUsStateCode(m[2]);
    if (maybeState.length === 2) {
      return { city: m[1].trim(), province: maybeState, zip: m[3] };
    }
  }

  if (/^\d{5}(?:-\d{4})?$/.test(raw)) {
    return { city: "", province: "", zip: raw };
  }

  return { city: raw, province: "", zip: "" };
}

function splitCityStateZipIntoFields(combined) {
  var parsed = parseCityStateZip(combined);
  if (!parsed.province && !parsed.zip) return parsed;

  var cityEl = document.getElementById("billing_city");
  var provEl = document.getElementById("billing_province");
  var zipEl = document.getElementById("billing_zip");
  if (cityEl && parsed.city) cityEl.value = parsed.city;
  if (provEl && parsed.province) provEl.value = parsed.province;
  if (zipEl && parsed.zip) zipEl.value = parsed.zip;
  return parsed;
}

function val(id) {
  var el = document.getElementById(id);
  return el ? String(el.value || "").trim() : "";
}

function collectBillingAddressFromForm() {
  var city = val("billing_city");
  var province = val("billing_province");
  var zip = val("billing_zip");

  // If City accidentally holds a combined "City, State, Zip" string, split it
  if (city && (/,/.test(city) || /\d{5}/.test(city))) {
    var parsedCity = parseCityStateZip(city);
    if (parsedCity.province || parsedCity.zip) {
      city = parsedCity.city;
      province = parsedCity.province || province;
      zip = parsedCity.zip || zip;
    }
  }

  province = normalizeUsStateCode(province);

  var fullName = val("name");
  var nameParts = fullName.split(/\s+/).filter(Boolean);
  var firstName = nameParts[0] || fullName;
  var lastName = nameParts.length > 1 ? nameParts.slice(1).join(" ") : "";

  return {
    customerName: fullName,
    customerNumber: val("billing_customer_number"),
    company: val("billing_company"),
    address1: val("billing_address1"),
    address2: "",
    city: city,
    province: province,
    zip: zip,
    country: val("billing_country") || "United States",
    phone: val("billing_phone"),
    email: val("email"),
    shipDate: val("billing_ship_date"),
    comments: val("billing_comments"),
    hearAbout: val("billing_hear_about"),
    firstName: firstName,
    lastName: lastName,
    cityStateZip: [city, province, zip].filter(Boolean).join(", ")
  };
}

function buildBulkOrderNote(formData, billing) {
  var lines = ["Bulk Order - Custom Items", ""];
  lines.push("Billing Information:");
  if (billing.customerName) lines.push("Customer Name: " + billing.customerName);
  if (billing.customerNumber) lines.push("Customer #: " + billing.customerNumber);
  if (billing.company) lines.push("Company Name: " + billing.company);
  if (billing.address1) lines.push("Street Address: " + billing.address1);
  if (billing.city || billing.province || billing.zip) {
    lines.push("City: " + (billing.city || ""));
    lines.push("State: " + (billing.province || ""));
    lines.push("Zip: " + (billing.zip || ""));
  } else if (billing.cityStateZip) {
    lines.push("City, State, Zip: " + billing.cityStateZip);
  }
  if (billing.phone) lines.push("Contact Phone: " + billing.phone);
  if (billing.email || formData.email) lines.push("Contact Email: " + (billing.email || formData.email));
  if (billing.shipDate) lines.push("Ship Date: " + billing.shipDate);
  if (billing.comments) lines.push("Comments/Questions: " + billing.comments);
  if (billing.hearAbout) lines.push("How did you hear about Chukar?: " + billing.hearAbout);
  return lines.join("\n");
}

function setButtonState(button, disabled, text) {
  button.disabled = disabled;
  button.textContent = text;
}

function checkCustomerExists(formData) {
  var data = new FormData();
  data.append("email", formData.email);
  return $.ajax({
    url: "https://api.chukar.com/bulk-order/fetch_customer.php",
    type: "POST",
    data: data,
    processData: false,
    contentType: false,
    dataType: "json"
  });
}

function createDraftOrder(orderData) {
  return $.ajax({
    url: "https://api.chukar.com/bulk-order/create_draft_order_tax.php",
    type: "POST",
    data: JSON.stringify(orderData),
    contentType: "application/json"
  });
}

function updateDraftOrderTags(draftOrderId) {
  return $.ajax({
    url: "https://api.chukar.com/bulk-order/update_draft_order_tags.php",
    type: "POST",
    data: JSON.stringify({
      draft_order_id: draftOrderId,
      bulk_order_id: draftOrderId
    }),
    contentType: "application/json"
  });
}

function handleDraftOrderSuccess(submitButton) {
  return function (response) {
    var data = typeof response === "string" ? JSON.parse(response) : response;
    console.log("Draft order created:", data);

    if (data.success && data.bulk_order_id) {
      updateDraftOrderTags(data.bulk_order_id)
        .then(function (tagResponse) {
          console.log("Tag update response:", tagResponse);
        })
        .catch(function (error) {
          console.error("Tag update error:", error);
        });
    }

    $("body").addClass("invoice_created");
    setButtonState(submitButton, true, "Order submitted for review!");

    setTimeout(function () {
      location.reload();
    }, 4000);
  };
}

function handleError(error) {
  console.error("Error:", error);
  if (error.responseText) console.error("Response Text:", error.responseText);

  var submitButton = document.getElementById("submit-payment");
  if (submitButton) setButtonState(submitButton, false, "Submit Order for Review");

  var message = "An error occurred while processing the request. Please check the console for details.";
  try {
    if (error.responseText) {
      var parsed = JSON.parse(error.responseText);
      if (parsed && parsed.error) {
        message = parsed.details
          ? parsed.error + ": " + (typeof parsed.details === "string" ? parsed.details : JSON.stringify(parsed.details))
          : parsed.error;
      }
    }
  } catch (e) { /* keep default */ }
  alert(message);
}
